import { useState, useEffect } from 'react';

/** Mobile breakpoint in pixels — matches Tailwind `md` (768px) */
export const MD_BREAKPOINT = 768;

/**
 * Returns true when the viewport width is below the given breakpoint.
 * Uses `window.matchMedia` for efficient, listener-based updates.
 */
export default function useMediaQuery(maxWidth: number): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < maxWidth : false
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${maxWidth - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [maxWidth]);

  return matches;
}
